import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import SelectMultiTerritorialUnits from "../../../../components/selects/SelectMultiTerritorialUnits";
import SelectMultiPesticidesType from "../../../../components/selects/SelectMultiPesticidesType";
import SelectMultiRealEstateConditions from "../../../../components/selects/SelectMultiRealEstateConditions";
import { dateFormat } from "../../../../utils";
import React, { useState } from "react";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterPesticides = (props: IProps) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);

  const handleStartDateChange = (date: any) => {
	setStartDate(date);
  };

  const disableEndDate = (current: any) => {
	return current && current.isBefore(startDate, 'day');
  };

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ 16 }>
		<Space>
		  <Form.Item
			label={t('general.start_date_period')}
			name={props.formField.periodStart}
		  >
			<DatePicker
			  format={dateFormat}
			  placeholder={t('general.select_date')}
			  onChange={handleStartDateChange}
			/>
		  </Form.Item>
		  <Form.Item
			label={t('general.end_date_period')}
			name={props.formField.periodEnd}
		  >
			<DatePicker
			  format={dateFormat}
			  placeholder={t('general.select_date')}
			  disabledDate={disableEndDate}
			/>
		  </Form.Item>
		</Space>
		<Col span={ 4 }>
		  <Form.Item label={ t('titles.types_of_pesticides') } name={ props.formField.pesticidesTypeId }>
			<SelectMultiPesticidesType/>
		  </Form.Item>
		</Col>
		<Col span={ 4 }>
		  <Form.Item label={ t('titles.territorial_units') } name={ props.formField.territorialUnitIds }>
			<SelectMultiTerritorialUnits/>
		  </Form.Item>
		</Col>
		<Col span={ 6 }>
		  <div style={ { marginTop: 30 } }>
			<Button
			  type="primary"
			  shape="default"
			  size="middle"
			  icon={ <SearchOutlined/> }
			  onClick={ props.onSearch }
			>
			  { t('general.search') }
			</Button>
			<Button size="small" type="link" onClick={ props.onReset } style={ { color: 'orange' } }>
			  { t('general.reset') }
			</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  )
}
